import React from 'react';
import { motion } from 'framer-motion';
import { GiHotDog, GiSandwich, GiMeat } from 'react-icons/gi';

const features = [
  {
    icon: GiHotDog,
    title: 'Saftige Pølser',
    description: 'Fra klassiske røde til gourmet-varianter'
  },
  {
    icon: GiSandwich,
    title: 'Lækre Sandwiches',
    description: 'Flæskesteg, frikadeller og meget mere'
  },
  {
    icon: GiMeat,
    title: 'Bøfsandwich',
    description: 'Den legendariske klassiker'
  }
];

export default function RentalFeatures() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
      <div className="grid md:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <motion.div
            key={feature.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            className="relative group"
          >
            <div className="absolute inset-0 bg-red-50 rounded-xl transform group-hover:scale-105 transition-transform duration-300" />
            <div className="relative p-8">
              <feature.icon className="w-12 h-12 text-red-600 mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}